import {PaginationComponent} from './shared/pagination/pagination.component';
import {LogsComponent} from './server-logs/logs.component';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {GoogleMapsModule} from '@angular/google-maps';
import {DatePipe} from '@angular/common';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CentralComponent} from './central/central.component';
import {LoginComponent} from './login/login.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {CarsComponent} from './cars/cars.component';
import {CarsExternalComponent} from './cars-external/cars-external.component';
import {DriversComponent} from './drivers/drivers.component';
import {MapComponent} from './map/map.component';
import {RestService} from './services/rest.service';
import {DataService} from './services/data.service';
import {UIBlockerService} from './services/uiblocker.service';
import {SvcInterceptor} from './services/svcinterceptor';
import {OverviewComponent} from './overview/overview.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {ExcelService} from './services/excel.service';
import {DialogCarComponent} from './dialog-car/dialog-car.component';
import {DialogGeneralComponent} from './dialog-general/dialog-general.component';
import {AirportcarsComponent} from './airportcars/airportcars.component';
import {AirportKioskComponent} from './airport-kiosk/airport-kiosk.component';
import {VouchersComponent} from './vouchers/vouchers.component';
import {OrdersComponent} from './orders/orders.component';
import {PosComponent} from './pos/pos.component';
import {OrderDetailsComponent} from './order-details/order-details.component';
import {ProfileComponent} from './profile/profile.component';
import {TranslatePipe} from './translate.pipe';
import {TranslationService} from './services/translation.service';
import {AppModalComponent} from './shared/app-modal/app-modal.component';
import {MessagesComponent} from './messages/messages.component';
import {UsersComponent} from './users/users.component';
import {DialogHostComponent} from './dialog-host/dialog-host.component';
import {OrderStatusDirective} from './shared/order-status.directive';
import {CarDisplayPipe} from './shared/car-display.pipe';

@NgModule({
    declarations: [
        PaginationComponent,
        LogsComponent,
        OrderStatusDirective,
        CarDisplayPipe,
        AppComponent,
        CentralComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        CarsComponent,
        CarsExternalComponent,
        DriversComponent,
        MapComponent,
        OverviewComponent,
        SidebarComponent,
        DialogCarComponent,
        DialogGeneralComponent,
        AirportcarsComponent,
        AirportKioskComponent,
        VouchersComponent,
        OrdersComponent,
        PosComponent,
        OrderDetailsComponent,
        ProfileComponent,
        MessagesComponent,
        UsersComponent,
        DialogHostComponent,
        TranslatePipe,
        AppModalComponent
    ],
    exports: [
        DialogCarComponent,
        DialogGeneralComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        AppRoutingModule,
        GoogleMapsModule], providers: [
        RestService,
        DataService,
        UIBlockerService,
        {provide: HTTP_INTERCEPTORS, useClass: SvcInterceptor, multi: true},
        ExcelService,
        DatePipe,
        TranslationService,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
export class AppModule {
}
